import { Card, Group, Text } from "@mantine/core";
import { IconCalendar, IconClock } from "@tabler/icons-react";

type Props = {
  currentDate: moment.Moment;
  currentTime: string;
  openCalender?: () => void;
  openTime?: () => void;
};

function TimeInfo({ currentDate, currentTime, openCalender, openTime }: Props) {
  return (
    <Card withBorder>
      <Group justify="space-between">
        <Group gap="5" onClick={openCalender}>
          <IconCalendar stroke={1} />
          <Text size="sm" fw="500">
            {currentDate.format("dddd jD jMMMM")}
          </Text>
        </Group>

        <Group gap="5" onClick={openTime}>
          <IconClock stroke={1} />
          <Text size="sm" fw="500">
            {currentTime}
          </Text>
        </Group>
      </Group>
    </Card>
  );
}

export default TimeInfo;
